import { Box, Grid } from "@mui/material";
import React from "react";
import SotialIcon from "./SotialIcon";
import logo from './../../assets/Logo/logo.png'
import RouteFooter from "./RouteFooter";
// import { Link } from "react-router-dom";
// import { useTranslation } from "react-i18next";
import IconSo from "./../../components/IconSo";


function Footer() {
    // const { t } = useTranslation()
    return (
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                pb: { md: '13px', xs: '30px' },
                pt: '13px',
                // background: "rgba(96 125 139 / 90%)",
                background: "#13103f",
                borderTopLeftRadius: '30px',
                borderTopRightRadius: '30px',
                position: 'relative',
            }}>
            <Grid container
                alignItems={'center'}
                sx={{
                    textAlign: { md: 'initial', xs: 'center' },
                    flexDirection: { md: 'row', xs: 'column-reverse' },
                    gap: { md: '0', xs: '8px' }
                }} >
                <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: 'center' }} >
                    <SotialIcon />
                </Grid>
                <Grid item xs={12} md={6} sx={{ display: 'flex', gap: .5, flexDirection: 'column' }} >
                    <RouteFooter />
                </Grid>
                <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: 'center' }} >
                    <img src={logo} height={100} width={100} alt="logo" />
                </Grid>
            </Grid>
            <IconSo />
        </Box>
    );
}

export default Footer;
